(function (global) {
  'use strict';

  /**
   * Wireframe challenge icons — simple line SVGs only.
   * Do not use cartoon menu-icon PNGs / photo badges here.
   */
  var ICONS = {
    odor:
      '<svg viewBox="0 0 40 40" fill="none" aria-hidden="true"><circle cx="20" cy="20" r="18" stroke="currentColor" stroke-width="1.75"/><path d="M14 24c1.5 2.5 4 4 6 4s4.5-1.5 6-4M16 16v2M24 16v2M13 12c2-2 5-3 7-3s5 1 7 3" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/></svg>',
    floor:
      '<svg viewBox="0 0 40 40" fill="none" aria-hidden="true"><circle cx="20" cy="20" r="18" stroke="currentColor" stroke-width="1.75"/><path d="M10 26h20M12 22h16M14 18h12M16 14h8" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/></svg>',
    touch:
      '<svg viewBox="0 0 40 40" fill="none" aria-hidden="true"><circle cx="20" cy="20" r="18" stroke="currentColor" stroke-width="1.75"/><path d="M20 12v10M16 18l4 4 4-4" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/><path d="M13 26h14" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/></svg>',
    moisture:
      '<svg viewBox="0 0 40 40" fill="none" aria-hidden="true"><circle cx="20" cy="20" r="18" stroke="currentColor" stroke-width="1.75"/><path d="M20 10c4 6 7 9 7 13a7 7 0 11-14 0c0-4 3-7 7-13z" stroke="currentColor" stroke-width="1.75" stroke-linejoin="round"/></svg>',
    experience:
      '<svg viewBox="0 0 40 40" fill="none" aria-hidden="true"><circle cx="20" cy="20" r="18" stroke="currentColor" stroke-width="1.75"/><path d="M20 11l2.4 4.9 5.4.8-3.9 3.8.9 5.4L20 23.4 15.2 26l.9-5.4-3.9-3.8 5.4-.8L20 11z" stroke="currentColor" stroke-width="1.75" stroke-linejoin="round"/></svg>',
    speed:
      '<svg viewBox="0 0 40 40" fill="none" aria-hidden="true"><circle cx="20" cy="20" r="18" stroke="currentColor" stroke-width="1.75"/><path d="M12 22h10l2-8 3 12 2-4h3" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    restroom:
      '<svg viewBox="0 0 40 40" fill="none" aria-hidden="true"><circle cx="20" cy="20" r="18" stroke="currentColor" stroke-width="1.75"/><path d="M16 14h8v6a4 4 0 01-8 0v-6zM14 28h12M18 12h4" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    grease:
      '<svg viewBox="0 0 40 40" fill="none" aria-hidden="true"><circle cx="20" cy="20" r="18" stroke="currentColor" stroke-width="1.75"/><path d="M12 24c2 3 5 5 8 5s6-2 8-5M14 16h12M16 20h8" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/></svg>',
    safety:
      '<svg viewBox="0 0 40 40" fill="none" aria-hidden="true"><circle cx="20" cy="20" r="18" stroke="currentColor" stroke-width="1.75"/><path d="M20 10l8 4v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10v-6l8-4z" stroke="currentColor" stroke-width="1.75" stroke-linejoin="round"/></svg>',
    budget:
      '<svg viewBox="0 0 40 40" fill="none" aria-hidden="true"><circle cx="20" cy="20" r="18" stroke="currentColor" stroke-width="1.75"/><rect x="12" y="13" width="16" height="14" rx="2" stroke="currentColor" stroke-width="1.75"/><path d="M16 18h8M16 22h5" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/></svg>',
    default:
      '<svg viewBox="0 0 40 40" fill="none" aria-hidden="true"><circle cx="20" cy="20" r="18" stroke="currentColor" stroke-width="1.75"/><path d="M13 20h14M20 13v14" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/></svg>'
  };

  var RULES = [
    { re: /odor|smell|urine/, icon: 'odor' },
    { re: /rubber floor|floor care|floor shine|hard floor|concrete|scrub|tile|carpet|spot|stain/, icon: 'floor' },
    { re: /high-touch|touchpoint|equipment|handle|console/, icon: 'touch' },
    { re: /moisture|wet|spill|dock|water/, icon: 'moisture' },
    { re: /member|guest|presentation|appearance|experience|image/, icon: 'experience' },
    { re: /speed|turnover|efficiency|after-hours|closing|fast/, icon: 'speed' },
    { re: /restroom|sanitation|toilet/, icon: 'restroom' },
    { re: /grease|food soil|kitchen|cafeteria/, icon: 'grease' },
    { re: /safety|ppe|slip|hazard|quiet|controlled/, icon: 'safety' },
    { re: /budget|storage|volunteer|startup|solo|purchase/, icon: 'budget' }
  ];

  function esc(v) {
    return String(v || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function iconForTitle(title) {
    var t = String(title || '').toLowerCase();
    for (var i = 0; i < RULES.length; i++) {
      if (RULES[i].re.test(t)) return ICONS[RULES[i].icon] || ICONS.default;
    }
    return ICONS.default;
  }

  function normalizePainPoints(items) {
    return (items || [])
      .map(function (p) {
        return { title: p.title, text: p.text || p.body || '' };
      })
      .filter(function (p) {
        return p.title;
      });
  }

  function renderCard(point) {
    return (
      '<li class="tcb-pain-challenges__card">' +
      '<span class="tcb-pain-challenges__icon tcb-pain-challenges__icon--wire" aria-hidden="true">' +
      iconForTitle(point.title) +
      '</span>' +
      '<strong>' +
      esc(point.title) +
      '</strong>' +
      '<span>' +
      esc(point.text) +
      '</span>' +
      '</li>'
    );
  }

  function render(options) {
    var zone = options.zone;
    var grid = options.grid;
    var headingEl = options.headingEl;
    var painPoints = normalizePainPoints(options.painPoints);
    var heading = options.heading;

    if (!grid || !painPoints.length) {
      if (zone) zone.hidden = true;
      return false;
    }

    if (headingEl && heading) headingEl.textContent = heading;
    grid.innerHTML = painPoints
      .map(function (p) {
        return renderCard(p);
      })
      .join('');
    if (zone) zone.hidden = false;
    return true;
  }

  global.TcbPainChallenges = {
    render: render,
    iconForTitle: iconForTitle,
    normalizePainPoints: normalizePainPoints
  };
})(window);
